import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type MarketPerformanceSubscription from 'lumen/models/market-performance/subscription';

export type MetricType =
  | 'bi_forecast'
  | 'budget'
  | 'ly'
  | 'net_sdly'
  | 'otb'
  | 'sdly';

export interface MetricVariance {
  absolute: number;
  percent: number;
}

export interface VarianceSet {
  adr: MetricVariance;
  occupancy: MetricVariance;
  revenue: MetricVariance;
  revpar: MetricVariance;
  rooms: MetricVariance;
}

export interface MarketPerformanceMetrics {
  adr: number | null;
  occupancy: number | null;
  revenue: number;
  revpar: number | null;
  rooms: number;

  variance: VarianceSet | null;
}

export type MarketPerformanceTotals = Record<
  MetricType,
  { totals: MarketPerformanceMetrics }
>;

export interface MarketPerformanceMeta {
  count: number;
  group_by: string;
  page_count: number;
  totals: MarketPerformanceTotals;
  warnings: string[];
}

export default class MarketPerformanceDataItem extends Model {
  [Type] = 'market-performance/data-item' as const;

  @belongsTo('market-performance/subscription', {
    async: false,
    inverse: 'dataItems',
  })
  declare subscription: MarketPerformanceSubscription;

  @attr('string') declare metricType: MetricType;
  @attr('string') declare month: string | null;

  @attr() declare totals: MarketPerformanceMetrics;
}
